module.exports = __webpack_public_path__ + "img/slika-11.1615e1db.png";